/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TOTPProvisionResponse } from '../models/TOTPProvisionResponse';
import type { TOTPRemoveResponse } from '../models/TOTPRemoveResponse';
import type { TOTPStatusResponse } from '../models/TOTPStatusResponse';
import type { TOTPVerifyProvisionRequest } from '../models/TOTPVerifyProvisionRequest';
import type { TOTPVerifyResponse } from '../models/TOTPVerifyResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TotpService {
    /**
     * Provision TOTP for the current user
     * Generate a TOTP secret and QR code for the authenticated user (requires escalation)
     * @param userSession
     * @returns TOTPProvisionResponse Successful Response
     * @throws ApiError
     */
    public static provisionTotp(
        userSession?: (string | null),
    ): CancelablePromise<TOTPProvisionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/totp/provision',
            cookies: {
                'user_session': userSession,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Verify TOTP provisioning
     * Verify TOTP code and complete enrollment for the current user (requires escalation)
     * @param requestBody
     * @param userSession
     * @returns TOTPVerifyResponse Successful Response
     * @throws ApiError
     */
    public static verifyTotpProvision(
        requestBody: TOTPVerifyProvisionRequest,
        userSession?: (string | null),
    ): CancelablePromise<TOTPVerifyResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/totp/verify-provision',
            cookies: {
                'user_session': userSession,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get TOTP status for the current user
     * Check if TOTP is enabled for the authenticated user
     * @param userSession
     * @returns TOTPStatusResponse Successful Response
     * @throws ApiError
     */
    public static getTotpStatus(
        userSession?: (string | null),
    ): CancelablePromise<TOTPStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/totp/status',
            cookies: {
                'user_session': userSession,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Remove TOTP for the current user
     * Remove TOTP authentication for the authenticated user (requires escalation)
     * @param userSession
     * @returns TOTPRemoveResponse Successful Response
     * @throws ApiError
     */
    public static removeTotp(
        userSession?: (string | null),
    ): CancelablePromise<TOTPRemoveResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/totp/remove',
            cookies: {
                'user_session': userSession,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
